import { render, staticRenderFns } from "./canvasWindow_m.vue?vue&type=template&id=23306fb5&"
import script from "./canvasWindow_m.vue?vue&type=script&lang=ts&"
export * from "./canvasWindow_m.vue?vue&type=script&lang=ts&"
import style0 from "./canvasWindow_m.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports